import { render, staticRenderFns } from "./AxAppFailureApiException.vue?vue&type=template&id=5f185481&"
import script from "./AxAppFailureApiException.vue?vue&type=script&lang=ts&"
export * from "./AxAppFailureApiException.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports